<template>
<div class="chapter">
<div class="inner_page">
<p class="western2" id="calibre_pb_4"> <br class="calibre1"/></p>
<p class="c3">Go far from me</p>
<p class="c3">But stay close</p>
<p class="c3">For I want to be alone</p>
<p class="c3">With someone near</p>
<p class="c1"> <br class="calibre1"/></p>
<p class="c1">D. Moore</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_10b66645e68cd802cc2e2d6047672dad_2rfwv1.ch.fixed.fc.tidied.stylehacked.xfixed_split_005.vue?799dce47